const pathName = (document.location.pathname + document.location.search);
const encodedPathName = encodeURIComponent(pathName).replace(/%2F/g, "-");
const STORAGE_KEY = "scrollPosition_" + encodedPathName;
let positionY;

function storeScrollPosition() {
  positionY = window.scrollY;
  sessionStorage.setItem(STORAGE_KEY, positionY);
}

function restoreScrollPosition() {
  positionY = sessionStorage.getItem(STORAGE_KEY);
  if (positionY !== null) {
    window.scrollTo(0, positionY);
  }
}

function checkOffset() {
  storeScrollPosition();
}

function isBackForward() {
  var entries = performance.getEntriesByType("navigation");
  return entries.some(function (entry) {
    return entry.type == "back_forward";
  });
}

document.addEventListener("DOMContentLoaded", function() {
  window.addEventListener("scroll", checkOffset, false);

  window.addEventListener("pageshow", function (event) {
    if (event.persisted) {
      // キャッシュから読み込まれた場合、back_forwardではないため別枠で検知する
      restoreScrollPosition()
    }
    if (isBackForward()) {
      restoreScrollPosition()
    }
  });
});
